export default "__VITE_ASSET__4c80fdb6__"